import type { TrackingContext } from "boot/plausible"
import { TrackingAction } from "boot/plausible"
import { AbstractEntity } from "src/entities/AbstractEntity"
import type { RouteLocationRaw } from "vue-router"
import { ROUTE_NAME_VIEW } from "src/router/routes"
import type { Feature } from "src/services/PermissionService"
import { useInventoryStore } from "stores/inventory-store"

export class ExchangeEntity extends AbstractEntity {
    protected readonly defaultIcon: string = "spi-landmark"
    protected readonly requiredFeatures: Feature[] = ["displayLists"]

    public getNameFromInventory(): string {
        return useInventoryStore().getExchangeById(this.id)?.name || ""
    }

    public getShortName(): string {
        return useInventoryStore().getExchangeById(this.id)?.mic || ""
    }

    public getIcon(): string {
        return useInventoryStore().getExchangeById(this.id)?.icon || this.defaultIcon
    }

    public getSubType(): string {
        return ""
    }

    public getTrackingAction(): TrackingAction {
        return TrackingAction.OPEN_VIEW
    }

    public getTrackingContext(): TrackingContext {
        return { exchangeName: this.getName(), exchangeId: this.id }
    }

    public getRouteOptions(): RouteLocationRaw {
        return { name: ROUTE_NAME_VIEW, query: { exchange: [this.id] } }
    }
}
